import { AccountsService } from 'base/accounts_service';
import { AccountStore } from 'base/account_store';
import { AnalyticsService } from 'base/analytics';
import { ToastQueue } from 'base/ui/toast';
import { FeatureFlagsStore } from 'blocks/flag_overrides';
import { installUpgradeSuccessDialog } from 'blocks/manage_account/install_upgrade_success_dialog';
import { installReferralEarningDialog } from 'blocks/referral_earning';
import { installReferralGiftBanner } from 'blocks/referral_gift_banner';

export function installOverlay({
  accountsService,
  analyticsService,
  accountStore,
  featureFlagsStore,
  toastQueue,
}: {
  accountsService: AccountsService;
  analyticsService: AnalyticsService;
  accountStore: AccountStore;
  featureFlagsStore: FeatureFlagsStore;
  toastQueue: ToastQueue;
}) {
  installUpgradeSuccessDialog();
  installReferralGiftBanner({ accountStore, analyticsService });
  if (featureFlagsStore.get('enableReferral')) {
    installReferralEarningDialog({
      accountsService,
      analyticsService,
      toastQueue,
      accountStore,
    });
  }
}
